import { render, staticRenderFns } from "./branchList.vue?vue&type=template&id=322c3ed0&scoped=true"
import script from "./branchList.vue?vue&type=script&lang=js"
export * from "./branchList.vue?vue&type=script&lang=js"
import style0 from "./branchList.vue?vue&type=style&index=0&id=322c3ed0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322c3ed0",
  null
  
)

export default component.exports